import { adminConstants } from '../constants';
import { AuthActions } from './';
import { AdminApi } from '../services';

export class AdminActions {
    static getAllAdmins () {
        return (dispatch) => {
            dispatch({type: adminConstants.GET_ALL_ADMINS_REQEUST});

            AdminApi.getAllAdmins()
                .then(AuthActions.ok(dispatch))
                .then((res) => {
                    // success
                    if(res.meta.success === true && res.data) {
                        dispatch({type: adminConstants.GET_ALL_ADMINS_SUCCESS, payload: [...res.data]});
                        return;
                    }

                    return dispatch({type: adminConstants.GET_ALL_ADMINS_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: adminConstants.GET_ALL_ADMINS_FAILURE});
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/admin.js